<template>
  <span class="material-symbols-outlined">
    {{ props.equipment.icon }}
    <v-tooltip
      activator="parent"
      location="bottom"
    >{{ props.equipment.name }}</v-tooltip>
  </span>
</template>

<script setup lang="ts">
type EquipmentType = {
  icon: string,
  type: string,
  name: string,
  path: string,
}

const props = defineProps<{
  equipment: EquipmentType,
}>()

</script>

<style scoped>
span {
  display: inline-flex !important;
  vertical-align: middle !important;
}
</style>
